<template>
  <div class="FAQ-page" :class="{ isEmpty: !tabsList.length }">
    <div class="FAQ" v-if="tabsList.length">
      <div class="f-hender">
        <span class="label">FAQ模块</span>
        <utabs v-model="faqType" :list="tabsList" @change="search" />
      </div>
      <div class="search fjcsb">
        <div class="s-left">
          <Input
            v-model="keywords"
            placeholder="关键字检索"
            @on-enter="search"
            clearable
          ></Input>
          <Button type="primary" @click="search">搜索</Button>
        </div>
        <div class="s-right">
          <Button class="add-btn" @click="add">反馈问题</Button>
          <Button class="lookFeedback-btn" type="text" @click="lookFeedback"
            >我的反馈记录</Button
          >
        </div>
      </div>
      <div class="body">
        <Table :columns="columns" :data="tableData"></Table>
      </div>
      <div class="footer">
        <Page
          :total="total"
          :page-size="pageSize"
          size="small"
          @on-change="pageChange"
        />
      </div>
      <editWin ref="editWin" :faqType="faqTypeObj" />
      <feedbackRecord ref="feedbackRecord" />
    </div>
    <empty v-else text="暂完权限"></empty>
  </div>
</template>

<script>
import { hasAuth } from "@/utils/uEdition.js";
import request from "@/utils/request";
import answer from "./answer.vue";
import editWin from "./editWin.vue";
export default {
  components: {
    editWin,
    answer,
  },
  computed: {
    faqTypeObj() {
      return this.tabsList.find((item) => item.value == this.faqType);
    },
  },
  data() {
    return {
      keywords: "",
      total: 0,
      pageSize: 20,
      pageIndex: 1,
      faqType: 0,
      tabsList: [],
      tableData: [],
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(answer, {
              props: {
                row: params.row,
              },
            });
          },
        },
        {
          title: "问题及解答",
          key: "question",
          minWidth: 300,
        },
      ],
    };
  },
  methods: {
    add() {
      this.$refs.editWin.open();
    },
    lookFeedback() {
      this.$refs.feedbackRecord.open();
    },
    search() {
      this.pageIndex = 1;
      this.getData();
    },
    getData() {
      if (this.faqType) {
        request
          .post("/saasbaihui/getFAQList", {
            keywords: this.keywords,
            faqType: this.faqType,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            faqStatus: 1,
          })
          .then((res) => {
            this.tableData = res.result;
          });
      }
    },
    pageChange(index) {
      this.pageIndex = index;
      this.getData();
    },
    setTabsList(index) {
      let arr = [];
      if (hasAuth("YZ-22-10")) {
        arr.push({
          label: "情志治疗",
          value: 1,
        });
      }
      if (hasAuth("YZ-22-11")) {
        arr.push({
          label: "临床",
          value: 2,
        });
      }
      if (hasAuth("YZ-22-12")) {
        arr.push({
          label: "品牌认知教育",
          value: 3,
        });
      }
      if (arr.length > 0) {
        this.faqType = arr[0].value;
      } else {
        this.faqType = "";
      }
      this.tabsList = arr;
    },
    init() {
      this.setTabsList();
      this.getData();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.FAQ {
  display: flex;
  flex-direction: column;
  height: 100%;
  .f-hender {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    & > span {
      margin-right: 20px;
    }
    .utabs {
      margin-bottom: 0;
      :deep {
        .utabs-item {
          border-radius: 15px;
          background: #f5f5f5;
          border: none;
          padding: 0 15px;
          font-size: 14px;
          &.active {
            color: #f50304;
            background: #fff2f1;
            font-weight: normal;
          }
        }
      }
    }
  }
  .search {
    margin-bottom: 15px;
    .s-left {
      display: flex;
      align-items: flex-start;
      & > * {
        margin-right: 15px;
      }
    }
    .s-right {
      & > * {
        margin-left: 15px;
      }
    }
  }
  .body {
    height: 100%;
    overflow-y: auto;
    margin-bottom: 10px;
  }
  :deep {
    td.ivu-table-expanded-cell {
      padding: 10px 0;
      background: #fff;
    }
  }
  .add-btn {
    border-color: #ff635f;
    color: #ff635f;
  }
  .lookFeedback-btn {
    color: #2991c0;
  }
}
.FAQ-page {
  height: 100%;
  &.isEmpty {
    display: flex;
    align-items: center;
    justify-self: center;
  }
}
</style>